const maxFollowersDefault = 100000
const maxBasicScoreDefault = 20

export enum DEFAULT_MAX_CONDITION {
  FOLLOWER = maxFollowersDefault,
  BASIC_SCORE = maxBasicScoreDefault,
}
